import React, { useState } from 'react';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production this would POST to a backend endpoint
    setSent(true);
  };

  return (
    <div className="container" style={{ padding: '2.5rem 1rem', maxWidth: 680 }}>
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you — reach out and we'll respond within 24–48 hours.</p>
      </div>

      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', marginTop: '2rem' }}>
        {/* Contact Info */}
        <div style={{ flex: '1 1 200px' }}>
          <div style={{ marginBottom: '1.25rem' }}>
            <div style={{ fontWeight: 700, marginBottom: '0.25rem', color: '#111827' }}>📧 Email</div>
            <a href="mailto:support@schoolkit2go.com" style={{ color: '#2563eb', fontSize: '0.92rem' }}>
              support@schoolkit2go.com
            </a>
          </div>
          <div style={{ marginBottom: '1.25rem' }}>
            <div style={{ fontWeight: 700, marginBottom: '0.25rem', color: '#111827' }}>🕐 Hours</div>
            <div style={{ fontSize: '0.88rem', color: '#6b7280', lineHeight: 1.6 }}>
              Monday – Friday<br />9:00 AM – 5:00 PM EST
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: '0.25rem', color: '#111827' }}>📦 Order Support</div>
            <div style={{ fontSize: '0.88rem', color: '#6b7280', lineHeight: 1.6 }}>
              Have an existing order?<br />
              <a href="/track-order" style={{ color: '#2563eb' }}>Track your order here</a>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div style={{ flex: '2 1 320px' }}>
          {sent ? (
            <div style={{ padding: '2rem', background: '#d1fae5', borderRadius: 10, textAlign: 'center', color: '#065f46' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>✅</div>
              <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.4rem' }}>Message sent!</div>
              <div style={{ fontSize: '0.9rem' }}>We'll get back to you within 24–48 hours.</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
              <div>
                <label className="form-label">Your Name</label>
                <input
                  className="form-input"
                  required
                  value={form.name}
                  onChange={e => set('name', e.target.value)}
                  placeholder="Jane Smith"
                />
              </div>
              <div>
                <label className="form-label">Email Address</label>
                <input
                  className="form-input"
                  type="email"
                  required
                  value={form.email}
                  onChange={e => set('email', e.target.value)}
                  placeholder="jane@example.com"
                />
              </div>
              <div>
                <label className="form-label">Subject</label>
                <select
                  className="form-select"
                  value={form.subject}
                  onChange={e => set('subject', e.target.value)}
                  required
                >
                  <option value="">Select a topic</option>
                  <option value="order">Order / Shipping</option>
                  <option value="kit">Kit or Product Question</option>
                  <option value="school">My School Isn't Listed</option>
                  <option value="return">Return / Refund</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="form-label">Message</label>
                <textarea
                  className="form-input"
                  required
                  rows={5}
                  value={form.message}
                  onChange={e => set('message', e.target.value)}
                  placeholder="How can we help you?"
                  style={{ resize: 'vertical' }}
                />
              </div>
              <button className="btn btn-primary" type="submit">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
